import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 15H20M4 19H13M13.54289 3.85V8.11432C13.54289 8.24693 13.49021 8.37411 13.39644 8.46788L9.46787 12.3964C9.27261 12.5917 8.95603 12.5917 8.76077 12.3964L4.89649 8.53212C4.70119 8.33686 4.70119 8.02028 4.89649 7.82502L8.82501 3.89645C8.91878 3.80268 9.04596 3.75 9.17857 3.75H13.44289C13.49812 3.75 13.54289 3.79477 13.54289 3.85Z" />
	</SVG>
);
